






























import Vue from "vue";
import Component from "vue-class-component";
import { zoneService } from "@/services/zone";
import { deskService } from "@/services/desk";
import { Desk } from "@/swagger/models";
import DataTable from "@/components/data/data-table.vue";
import { DataTableField, DataTableMultiAction } from "@/components/data/data-table";
import { Prop } from "vue-property-decorator";
import { DateTime } from "luxon";
import MoveDesksModal from "@/components/modals/move-desks.vue";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "desks-table",
    components: {
        // MoveDesksModal,
        DataTable,
    },
})
export default class DesksTable extends Vue {
    @Prop({ default: false })
    withCreate: boolean;

    @Prop()
    zoneId: number;

    @Prop()
    officeId: number;

    items: Desk[] = [];
    loading = false;

    fields: DataTableField<Desk>[] = [
        {
            label: "ID",
            field: "id",
            compact: true,
        },
        {
            label: "Name",
            field: "name",
        },
        {
            label: "Zone",
            field: "zone.name",
        },
        {
            label: "Status",
            field: "deletedAt",
            format: (value: string | null) => {
                if (value) return "inactive";
                return "active";
            },
        },
        {
            label: "Created",
            field: "createdAt",
            compact: true,
            format: (d: string) => DateTime.fromISO(d, { zone: "utc" }).toRelative(),
        },
        {
            label: "Updated",
            field: "updatedAt",
            compact: true,
            format: (d: string) => DateTime.fromISO(d, { zone: "utc" }).toRelative(),
        },
    ];

    multiSelectActions: DataTableMultiAction<Desk>[] = [
        // {
        //     tooltip: "Move selected desks to another zone",
        //     icon: "mdi-map-outline",
        //     label: "Change zone",
        //     callback: () => {
        //         // @ts-ignore ($el DOES exist)
        //         this.$refs.moveDesksModalButton.$el.click();
        //     },
        // },
        {
            tooltip: "Deactivate selected desks",
            icon: "mdi-cancel",
            label: "Deactivate",
            callback: async (desks: Desk[]) => {
                // prettier-ignore
                if (!confirm(`Are you sure you want to deactivate ${desks.length} desk(s)? Any pending reservations will be cancelled! This can not be undone.`)) return;
                this.loading = true;
                await deskService.deactivateDesks(desks.filter((d) => !d.deletedAt).map((d) => d.id));
                await this.loadItems();
            },
        },
        {
            tooltip: "Activate selected desks",
            icon: "mdi-check",
            label: "Activate",
            callback: async (desks: Desk[]) => {
                if (!confirm(`Are you sure you want to activate ${desks.length} desk(s)?`)) return;
                this.loading = true;
                await deskService.activateDesks(desks.filter((d) => !!d.deletedAt).map((d) => d.id));
                await this.loadItems();
            },
        },
    ];

    selection: Desk[] = [];

    async created() {
        if (!this.zoneId && !this.officeId) throw new Error("<desk-table> needs either an officeId or a zoneId");

        // if zoneId is set, we don't need to display the zone's name, so we get rid of it
        if (this.zoneId) this.fields = this.fields.filter((f) => f.field !== "zone.name");

        await this.loadItems();
    }

    async loadItems() {
        try {
            this.loading = true;
            this.items.length = 0;

            if (this.officeId) {
                const zones = await zoneService.findNew({
                    params: {
                        office: this.officeId,
                    },
                });

                for (let zone of zones.data) {
                    const res = await deskService.findNew({
                        params: {
                            zone: zone.id,
                            withDeleted: true,
                        },
                    });

                    // add zone to every desk
                    res.data.forEach((desk) => (desk.zone = zone));

                    this.items.push(...res.data);
                }
            } else {
                const res = await deskService.findNew({
                    params: {
                        zone: this.zoneId,
                    },
                });

                this.items = res.data;
            }
        } catch (e) {
            console.warn(e);
        } finally {
            this.loading = false;
        }
    }

    clickItem(item: Desk) {
        this.$router.push({
            name: "desk",
            params: {
                deskId: item.id.toString(),
            },
        });
    }

    async createDesks() {
        await deskService.generateDesks(this.zoneId);
        await this.loadItems();
    }
}
